/**
 * emailBlacklist.ts — Liste bekannter Wegwerf-Email-Provider
 *
 * Wird von validation.ts (isBlacklistedEmail) verwendet, um während
 * der Registrierung Einmal-/Wegwerf-Email-Adressen zu blockieren.
 *
 * Pflege-Hinweise:
 * - Einträge immer in Kleinbuchstaben (Vergleich ist case-insensitive,
 *   aber Eingabe klein halten sorgt für Konsistenz).
 * - Nur Domains, keine Subdomains (Check vergleicht nur den Teil nach "@").
 * - Bei Erweiterung: sortiert alphabetisch einfügen.
 * - Referenzquelle für weitere Domains:
 *   https://github.com/disposable-email-domains/disposable-email-domains
 *
 * Die Liste ist bewusst kuratiert (nicht komplett). Für Platform-Betrieb
 * reichen die bekanntesten Anbieter + deren populärste Aliase. Eine
 * vollständige Übernahme der 3.500+ Domains aus der Referenzquelle ist
 * weder gewünscht noch nötig — die Top-~150 fangen den Großteil der
 * realen Spam-Registrierungen ab.
 *
 * @module lib/emailBlacklist
 */

export const EMAIL_DOMAIN_BLACKLIST: readonly string[] = [
  '0815.ru',
  '10minutemail.com',
  '10minutemail.de',
  '10minutemail.net',
  '10minutemail.org',
  '20minutemail.com',
  '20minutemail.it',
  '33mail.com',
  'anonbox.net',
  'anonmails.de',
  'anonymbox.com',
  'beefmilk.com',
  'binkmail.com',
  'bobmail.info',
  'bund.us',
  'burnermail.io',
  'byom.de',
  'cool.fr.nf',
  'courriel.fr.nf',
  'deadaddress.com',
  'disposable-email.ml',
  'disposable.ml',
  'disposablemail.com',
  'dispostable.com',
  'dropmail.me',
  'emailfake.com',
  'emailondeck.com',
  'emailsensei.com',
  'fakeinbox.com',
  'fakemail.net',
  'fakemailgenerator.com',
  'fastacura.com',
  'filzmail.com',
  'freemail.ms',
  'front14.org',
  'getairmail.com',
  'getnada.com',
  'grr.la',
  'guerrillamail.biz',
  'guerrillamail.com',
  'guerrillamail.de',
  'guerrillamail.info',
  'guerrillamail.net',
  'guerrillamail.org',
  'guerrillamailblock.com',
  'hidemail.de',
  'inbox.si',
  'inboxalias.com',
  'incognitomail.com',
  'jetable.fr.nf',
  'jetable.net',
  'jetable.org',
  'jnxjn.com',
  'mail-temporaire.fr',
  'mail.tm',
  'mail7.io',
  'maildrop.cc',
  'mailexpire.com',
  'mailforspam.com',
  'mailinator.com',
  'mailinator.net',
  'mailinator.org',
  'mailinator2.com',
  'mailnesia.com',
  'mailnull.com',
  'mailsac.com',
  'meltmail.com',
  'mintemail.com',
  'moakt.com',
  'mohmal.com',
  'mt2015.com',
  'mt2016.com',
  'mvrht.com',
  'mytemp.email',
  'mytrashmail.com',
  'nobulk.com',
  'noclickemail.com',
  'nomail.xl.cx',
  'notmailinator.com',
  'nowmymail.com',
  'objectmail.com',
  'onewaymail.com',
  'postacin.com',
  'proxymail.eu',
  'rcpt.at',
  'rmqkr.net',
  'sharklasers.com',
  'sogetthis.com',
  'spam4.me',
  'spambog.com',
  'spambog.de',
  'spambog.ru',
  'spambox.us',
  'spamex.com',
  'spamfree24.com',
  'spamfree24.de',
  'spamfree24.eu',
  'spamfree24.org',
  'spamgourmet.com',
  'spamherelots.com',
  'spamhole.com',
  'spaml.de',
  'spamspot.com',
  'squizzy.eu',
  'streetwisemail.com',
  'suremail.info',
  'tagyourself.com',
  'temp-mail.org',
  'temp-mail.ru',
  'tempail.com',
  'tempemail.com',
  'tempemail.net',
  'tempinbox.com',
  'tempmail.com',
  'tempmail.de',
  'tempmail.eu',
  'tempmail.net',
  'tempmaildemand.com',
  'tempmailer.com',
  'tempmailer.de',
  'thankyou2010.com',
  'throwaway.email',
  'throwawaymail.com',
  'tmail.ws',
  'tmails.net',
  'trash-mail.at',
  'trash-mail.com',
  'trash-mail.de',
  'trash2009.com',
  'trashmail.at',
  'trashmail.com',
  'trashmail.de',
  'trashmail.me',
  'trashmail.net',
  'trashmail.org',
  'trashmailer.com',
  'trbvn.com',
  'tyldd.com',
  'veryrealemail.com',
  'wegwerfadresse.de',
  'wegwerfemail.de',
  'wegwerfmail.de',
  'wegwerfmail.info',
  'wegwerfmail.net',
  'wegwerfmail.org',
  'wh4f.org',
  'whyspam.me',
  'yopmail.com',
  'yopmail.fr',
  'yopmail.net',
  'youmail.ga',
  'zetmail.com',
  'zippymail.info',
];
